module.exports = __webpack_public_path__ + "static/media/parser.html.31d6cfe0.txt";